import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { ControlContainer, NgForm } from '@angular/forms';
import { WorkflowComponent } from '../../workflow.component';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import * as _ from 'lodash';
import DateHelpers from '../../../_infrastructure/DateHelpers';
import { StepDetailsService } from '../../../_infrastructure/StepDetailsService/StepDetailsService';

@Component({
    selector: 'observations',
    templateUrl: './observations.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class ObservationsComponent implements OnInit, OnDestroy, ICardComponent {
  public cardData: models.ObservationsVM = {} as models.ObservationsVM;
  public cardConfiguration: models.CardVM;
  public isWorkflowOnSubscriber: boolean = false;
  public isWorkflowPgpv: boolean = false;

  public revisionReason: string;
  public needRevision: boolean = false;
  public subscriberType: string;
  public professionalClass: string;
  public minDate: Date;
  public maxDate: Date;


  public isWorkflowIncapacity: boolean = false;

  public parentWorkflow: WorkflowComponent;

  //@CommonData(DomainCodes.domains)
  //public domains: models.DimensionVM[];
  //@CommonData(DomainCodes.country)
  //public countries: models.DimensionVM[];   98 Magistrados, 91 corpos diplomaticos, 103 GNR para a versão 1
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.reflectionDeadlines)
  public reflectionDeadlines: models.DimensionVM[];

  constructor(private http: HttpClient, private activeRoute: ActivatedRoute) {

  }

  ngOnInit(): void {
    this.needRevision = this.parentWorkflow.workflowInstance.formData.StepFinalize && this.parentWorkflow.workflowInstance.formData.StepFinalize['SendWorkflow'].revisionNeeded == "true";
    this.revisionReason = this.needRevision && this.parentWorkflow.workflowInstance.formData.StepFinalize['SendWorkflow'].revisionReason;
    if (this.isVersion2()) {
      if (!this.checkSteps()) {
        this.subscriberType = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus'].subscriberTypeCode;
        this.professionalClass = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus'].professionalCategoryCode;
      } else {
        this.professionalClass = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.professionalCategoryCode;
        this.subscriberType = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode;
      }
      this.minDate = this.getMinDate();
      this.maxDate = this.getMaxDate();
    }

    this.isWorkflowOnSubscriber = this.parentWorkflow.isWorkflowOnSubscriber;
    this.isWorkflowPgpv = this.parentWorkflow.isWorkflowPgpv;
    this.isWorkflowIncapacity =
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001F" ||
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001G" ||
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001H" ||
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001I" ||
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001J" ||
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001K" ||
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001U" ||
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001Y" ||

      this.parentWorkflow.workflowInstance.workflowCode === "PEDI005I" ||
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI005K";
  }

  ngOnDestroy(): void {
  }

  isVersion2() {
    let result = false;
    if (this.parentWorkflow.workflowInstance.formData['Version']?.toString() === '2') {
      result = true;
    }
    return result;
  }

  checkSteps() {
    let result = false;
    for (let i = 0; i < this.parentWorkflow.steps.length; i++) {
      if (this.parentWorkflow.steps[i].stepCode === "StepSubscriberCGA") {
        result = true;
        break;
      }
    }
    return result;
  }

  onPrevComChanged(event: any) {
    if (!isNullOrUndefined(event) && event == "true")
      this.parentWorkflow.workflowInstance.formData['StepObs']['CommunicationDetail'].reflectionDeadlineCode = "5";
  }

  getOrderReflectionDeadlines(): models.DimensionVM[] {

    var lst = this.reflectionDeadlines;
    if (!this.parentWorkflow.isWorkflowSubmited) {
      lst = lst.filter((v, i, a) => v.isActive);
    }

    return _.sortBy(lst, (obj) => { return parseInt(obj.code) });
  }

  getMinDate() {
    let result: Date;
    let effMapEntries: models.EffectivityEntryVM[] = this.parentWorkflow.workflowInstance.formData['StepMap']?.['EffectivityMap']?.['effectivityList'];
    if (!effMapEntries)
      return;

    let lastEntryEffMap = effMapEntries[effMapEntries.length - 1];
    result = new Date(new Date(lastEntryEffMap?.endDate).setDate(effMapEntries[effMapEntries.length - 1]?.endDate.getDate()));
    return result;
  }

  getMaxDate() {
    let result: Date;
    if (this.parentWorkflow.workflowInstance.workflowCode == 'PEDI001M') {
      result = new Date();
    } else {
      result = new Date(new Date(Date.now()).setDate(new Date(Date.now()).getDate() + 90));
    }
    
    return result;
  }

  isSpecificLegalFundament():boolean {
    let result = false;
    let voluntaryFundaments = ['PEDI001M', 'PEDI001Q', 'PEDI001P', 'PEDI001R'];
    if (voluntaryFundaments.indexOf(this.parentWorkflow['workflowInstance']['workflowCode']) >= 0) {
      result = true;
    }

    return result;
  }

  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }

  onDateChange(event: any, dp: any) {
    let object = new Date(this.cardData[event.target.name]).toISOString().split('T')[0];
    DateHelpers.onDateChange(event, dp, object);
  }
}
